"use client";

import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  DialogTitle,
  DialogTrigger,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
} from "@medimo/ui";
import { useRequestResetPasswordDialog } from "../../hooks/use-request-reset-password-dialog";

type RequestResetPasswordDialogProps = {
  onRequestRecovery: (email: string) => Promise<void>;
  logoSrc: string;
};

export const RequestResetPasswordDialog = ({
  onRequestRecovery,
  logoSrc,
}: RequestResetPasswordDialogProps) => {
  const { form, onSubmit } = useRequestResetPasswordDialog(onRequestRecovery);
  return (
    <Dialog>
      <DialogTrigger className="w-full" asChild>
        <Button className="w-full" variant="ghost" type="button">
          パスワードを忘れた方はこちら
        </Button>
      </DialogTrigger>
      <DialogContent className="mx-auto flex flex-col gap-6 px-6 py-11 max-[768px]:max-w-[90vw]">
        <img
          src={logoSrc}
          alt="logo"
          width={300}
          height={100}
          className="mx-auto"
        />
        <DialogTitle className="mx-auto text-xl">
          パスワードをお忘れですか？
        </DialogTitle>
        <p className="text-center">
          入力したメールアドレスに、パスワード再発行のご案内をお送りします。
        </p>
        <Form {...form}>
          <form
            className="flex flex-col gap-8"
            onSubmit={form.handleSubmit(onSubmit)}
          >
            <FormField
              control={form.control}
              name="email"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>メールアドレス</FormLabel>
                  <FormControl>
                    <Input
                      autoComplete="email"
                      placeholder="example@medimo.ai"
                      type="email"
                      {...field}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <div className="flex gap-6">
              <DialogClose asChild>
                <Button
                  className="w-full font-bold"
                  type="button"
                  variant="secondary"
                >
                  戻る
                </Button>
              </DialogClose>
              <Button
                type="submit"
                className="w-full font-bold"
                disabled={form.formState.isSubmitting}
              >
                送信
              </Button>
            </div>
          </form>
        </Form>
      </DialogContent>
    </Dialog>
  );
};
